<template>
  <v-container fluid>
    <v-alert 
      v-if="lstSecciones == undefined || lstSecciones.length == 0" 
      type="warning">
      No se han cargado secciones para esta encuesta.
    </v-alert>

    <v-stepper v-else v-model="e6" vertical >

      <div v-for="(item, index) in lstSecciones" :key="'seccion_' + item.SECCION.ID_SECCION">

        <v-stepper-step :complete="(e6 > index + 1) || consulta || vistaPrevia" :step="index + 1" :editable="consulta || vistaPrevia || (e6 > index + 1)" :edit-icon="`mdi-numeric-${index + 1}`">
          <span 
            class="mb-2" 
            style='font-size:1.3rem; margin:0 auto;'
          >
            {{ item.SECCION.NOMBRE_SECCION }}
          </span>
          <small style="font-size:1rem; word-break: break-word;" >{{ item.SECCION.DESCRIPCION_SECCION }}</small>
        </v-stepper-step>

        <v-stepper-content :step="index + 1">
          
          <v-form 
            :ref="`formSeccion${index + 1}`" 
            v-model="valid[index]" 
            :lazy-validation="lazy[index]"
          >
          
            <pregunta-encuesta 
              v-for="(itemP, indexP) in item.ARREGLO_PREGUNTA" 
              :key="'pregunta_' + itemP.PREGUNTA.ID_PREGUNTA + '_seccion_' + item.SECCION.ID_SECCION" 
              :obj-pregunta="itemP"
              :id-seccion="item.SECCION.ID_SECCION"
              :set-respuesta="setRespuestaMostrar"
              :set-value-parametro="setValueParametro"
              :mostrar-pregunta="mostrarPreguntaByIdPregunta(itemP.PREGUNTA.ID_PREGUNTA)"
              :consulta="consulta"
              :vista-previa="vistaPrevia"
              :encuesta-autenticada="encuestaAutenticada"
              :mostrarPOrdenamiento="mostrarPOrdenamiento"
            ></pregunta-encuesta>

          </v-form>
          
          <div v-if="!consulta && !vistaPrevia" style="padding-bottom:10px;">
            <v-btn v-if="index != 0" class="mx-2" color="default"  @click="e6 = index">Regresar</v-btn>
            <v-btn v-if="index != valid.length - 1" class="mx-2" color="primary" :disabled="!valid[index]" @click="e6 = index + 2">Continuar</v-btn>
            <v-btn v-if="index == valid.length - 1" class="mx-2" color="success" :disabled="!valid[index]" @click="openDialogEnviarEncuesta">Finalizar encuesta</v-btn>
          </div>
        </v-stepper-content>
        

      </div>
    </v-stepper>
  </v-container>
</template>

<script>

export default {
  name: 'SeccionesEncuesta',
  components: {
     PreguntaEncuesta: () => import('../encuesta/PreguntaEncuesta'),
/*    SolicitudPrestacionDetalle: () => import('../molecules/SolicitudPrestacionDetalle'), */
  },
  props: {
    lstSecciones: {
      type: Array,
      required: true,
    },
    setRespuesta: {
      type: Function,
      required: true
    },
    removePreguntaDep: {
      type: Function,
      required: true
    },
    openDialogEnviarEncuesta: {
      type: Function,
      required: true
    },
    setValueParametro: {
      type: Function,
      required: true
    },
    consulta: {
      type: Boolean,
      required: true
    },
    vistaPrevia: {
      type: Boolean,
      default: false
    },
    encuestaAutenticada: {
      type: Boolean,
      default: false
    },
    mostrarPOrdenamiento:{
      type: Boolean,
      default:false
    }
    
  },
  data: () => ({
    e6: 1,

    mostrarPreguntas: [],

    valid: [],
    lazy: [],

    snackbar: false,
    snackbarColor: '',
    snackbarTexto: '',
    
  }),
  computed: {
/*     ...mapGetters('oidc', ['oidcUser']),*/ 
  },
  watch: { },
  beforeMount() {
    this.inicializarValidador();
  },
  methods: {
    inicializarValidador(){

      var self = this;

      self.valid = [];
      self.lazy = [];
      
      this.lstSecciones.forEach(function(item){
        self.valid.push(false);
        self.lazy.push(false);
      })

    },
    mostrarPreguntaByIdPregunta(idPregunta){
      var preg = this.mostrarPreguntas.filter(n=>n == idPregunta).length;
      return preg == 0 ? false : true;
    },
    setRespuestaMostrar (idSeccion, idPregunta, idRespuesta, respuesta, valorNum, capturaLibre){
    
     var self = this;
      
      self.lstSecciones.forEach(function(seccion) {
        var lstPreg = seccion.ARREGLO_PREGUNTA == undefined ? [] : seccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA_DEPENDIENTE == idPregunta);

        lstPreg.forEach(function(preg) {
          
          var accion = 0; // -1 Quitar pregunta, 1 Agregar pregunta a arreglo

          if(preg.PREGUNTA.ID_CAT_RESPUESTA_DEPENDIENTE == 0){
            if(respuesta != null && respuesta != undefined && respuesta != ""){
              accion = 1;
            }
            else{
              accion = -1
            }
          }
          else{
            if(preg.PREGUNTA.ID_CAT_RESPUESTA_DEPENDIENTE == idRespuesta){
              accion = 1;
            }
            else{
              accion = -1;
            }
          }

          if(accion == 1){
            self.mostrarPreguntas.push(preg.PREGUNTA.ID_PREGUNTA)
          }
          else{
            self.mostrarPreguntas = self.mostrarPreguntas.filter(function(item) {
                return item !== preg.PREGUNTA.ID_PREGUNTA
            })

            self.removePreguntaDep(preg.PREGUNTA.ID_PREGUNTA)
          }
          
          //if(preg.PREGUNTA.RESPUESTA_PREGUNTA!=""&&preg.PREGUNTA.RESPUESTA_PREGUNTA!=nullpreg.PREGUNTA.RESPUESTA_PREGUNTA!=undefined){
//console.log("Preg")
//console.log(preg.PREGUNTA.RESPUESTA_PREGUNTA)
self.setRespuestaMostrar (idSeccion, preg.PREGUNTA.ID_PREGUNTA, 0, null, valorNum, capturaLibre);

         // }

        
        });
      })
// self.setRespuesta(idSeccion, idPregunta, idRespuesta, respuesta, valorNum, capturaLibre);    
//console.log("Preg")
//console.log(idRespuesta)
//console.log("idRespuesta" +idRespuesta)
//console.log("respuesta" +respuesta)
//if(idRespuesta!=0||respuesta!=null){
if(idRespuesta!=0||respuesta!=null){
  //console.log("ordenamiento" )
  //console.log(respuesta)
  self.setRespuesta(idSeccion, idPregunta, idRespuesta, respuesta, valorNum, capturaLibre);
}
/*
else{

var arrPreguntas;       
  self.lstSecciones.forEach(function(sec) {
      if(sec.SECCION.ID_SECCION==idSeccion){
        arrPreguntas=sec.ARREGLO_PREGUNTA;
      }
  });
  var preguntaInfo=null;
  if(arrPreguntas!=undefined){
    arrPreguntas.forEach(rp=>{
    if(rp.PREGUNTA.ID_PREGUNTA==idPregunta){
        preguntaInfo=rp;
    }
    });
      console.log("No tiene id")
      console.log(idRespuesta)
    
      console.log("Pregunta ingresada")
      console.log(preguntaInfo.PREGUNTA)
      console.log(respuesta, capturaLibre)
      }
}
*/
    }
  },
};
</script>


<style>
.v-stepper__label {
  width: 100%;

}

.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
  text-shadow: 0px 0px 0px #0e345b;
}
</style>